import { Attachment, AttachmentFilesTypes } from 'Shared/types/Attachment.type';

type getFileTypeProps = {
  attachment: Attachment;
};

export const downloadFileInZoom = url => {
  (window as any).zoomSdk.openUrl({ url });
};

export const getFileType = ({ attachment }: getFileTypeProps) => {
  const contentType = attachment.contentType;

  if (
    contentType.includes('jpg') ||
    contentType.includes('jpeg') ||
    contentType.includes('png') ||
    contentType.includes('gif')
  )
    return AttachmentFilesTypes.IMAGE;
  else if (contentType.includes('excel') || contentType.includes('spreadsheetml.sheet'))
    return AttachmentFilesTypes.MSEXCEL;
  else if (contentType.includes('csv')) return AttachmentFilesTypes.CSV;
  else if (contentType.includes('mp4') || contentType.includes('webm') || contentType.includes('ogg'))
    return AttachmentFilesTypes.VIDEO;
  else if (contentType.includes('msword') || contentType.includes('wordprocessingml.document'))
    return AttachmentFilesTypes.MSWORD;
  else if (contentType.includes('powerpoint') || contentType.includes('presentation'))
    return AttachmentFilesTypes.MSPPT;
  else if (contentType.includes('pdf')) return AttachmentFilesTypes.PDF;
  else if (contentType.includes('audio')) return AttachmentFilesTypes.AUDIO;
  else if (contentType.includes('zip') || contentType.includes('tar') || contentType.includes('gzip'))
    return AttachmentFilesTypes.ARCHIVE;
  else return AttachmentFilesTypes.FILE;
};
